<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <air-search-bar
        :filter="filter"
        :show-price-no="true"
        :is-show-created-by="true"
        :show-level="showLevel"
        :show-currency="true"
        :show-all-in="true"
        :is-query="true"
        config-id="AirRealList"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @onGridRefresh="gridRefresh"
        @reset="rowData=[]"
      >
        <template slot="operations">
          <el-button no="onQuotation" type="primary" @click="onQuotation()">{{ $t('Pricing.Quotation') }}</el-button>
          <el-button no="onSubscribe" type="primary" @click="onSubscribe()">{{ $t('Pricing.Subscribe') }}</el-button>
          <el-button no="exportToExcel" type="primary" @click="exportToExcel()">{{ $t('Pricing.Export') }}</el-button>
          <span style="margin-left: 20px">{{ globalMsg }}</span>
        </template>
      </air-search-bar>
      <air-data-grid
        :config-module="configModule"
        :grid-options="gridOptions"
        :row-data="rowData"
        :all-in="filter.allIn"
        :currency="filter.currency"
      />
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" no="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
    <subscribe-dialog v-if="subscribe.visible" :visible="subscribe.visible" price-name="PA" :is-ar="true" @close="onSubscribeClose" />
    <el-dialog
      v-if="exportDialog.visible"
      v-el-drag-dialog
      :visible.sync="exportDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column; text-align: center">
        <span style="line-height: 40px;">{{ $t('Pricing.ExportMode') }}？</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="exportAll" type="primary" style="margin-right: 30px;" @click="exportAll()">{{ $t('Pricing.WYSIWYG') }}</el-button>
        <el-button no="ExportByTemplate(" type="primary" style="margin-right: 30px;" @click="ExportByTemplate()">{{ $t('Pricing.ExportByTemplate') }}</el-button>
        <el-button no="cancel" @click="exportDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <quotation-detail-dialog
      v-if="quotationDetail.visible"
      :visible.sync="quotationDetail.visible"
      :model="quotationDetail.quotation"
      :filter-level="filter.level"
      :editing="quotationDetail.isEditing"
      :show-quotation-detail="quotationDetail.showDetail"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import {
  queryPriceAirRealDetail,
  queryPriceAirRealSimplePriceNo,
  exportByTemplate
} from '@/api/price/priceAir'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import SubscribeDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/SubscribeDialog'
import StrUtils from '@/utils/StrUtils'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import DateUtils from '@/utils/dateUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import convertResToBlob from '@/utils/convertResToBlob'
import QuotationDetailDialog from '@/views/cargo/v0/Price/Quotation/components/quotationDetailDialog'
import { Quotation } from '@/class/model/price/Quotation'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import AirSearchBar from '@/views/cargo/v0/Price/components/query/airSearchBar'
import AirDataGrid from '@/views/cargo/v0/Price/components/grid/airDataGrid'
import { getObjectByCache, resolveSpecificField2Value } from '@/utils/basicDataCache'

export default {
  name: 'AirRealList',
  components: {
    AirDataGrid,
    AirSearchBar,
    QuotationDetailDialog,
    SubscribeDialog
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: () => false }, // 禁用
    isShowCreatedBy: { type: Boolean, default: true },
    isManageModule: { type: Boolean, default: false },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    showCurrency: { type: Boolean, default: false },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    isHistory: { type: Boolean, default: false },
    configModule: { type: String, default: '' }
  },
  data() {
    return {
      URL,
      proxy: {},
      selectTypeNames: TYPE_NAMES,
      rowData: [],
      globalMsg: '', // 查询条数和勾选条数显示
      tenantUtil: {},
      showLevel: true,
      txtRemarks: '',
      remarkChange: false,
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        opOffice: 0,
        carrier: 0,
        pol: '',
        pod: '',
        cod: '',
        col: '',
        cmbCreatedBy: 'createdBy',
        level: '',
        currency: 'RMB',
        allIn: false,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        createdBy: 0
      },
      quotationDetail: { // 详情
        quotation: null,
        visible: false,
        isEditing: false,
        showDetail: false
      },
      showDetail: false,
      fullscreenLoading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClickedEvent,
        onRowSelected: this.onRowChecked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      subscribe: {
        visible: false
      },
      exportDialog: {
        visible: false
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
    },
    fetchOrderRequirement() {
    },
    // 查询
    toSimpleQuery(proxy) {
      this.fullscreenLoading = getLoading()
      proxy.state = this.isHistory ? PriceConstant.PRICE_STATE_HISTORY : PriceConstant.PRICE_STATE_EFFECTIVE
      proxy.history = this.isHistory
      queryPriceAirRealSimplePriceNo(proxy).then((res) => {
        this.handleQueryData(res)
      })
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      const isNoRecord = !(_resMap)
      if (isNoRecord || _resMap.hasOwnProperty('Count') && Number(_resMap['Count'][0]) === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
        this.rowData = []
        return
      }
      const count = Number(_resMap['Count'][0])
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      let tenantId = NaN
      let rs = []
      for (const item in _resMap) {
        if (item.indexOf('PA') === 0) {
          tenantId = Number(item.substr(2))
          const rs_tenant = _resMap[item]
          if (rs_tenant && rs_tenant.length > 0) {
            PriceUtils.recordTenant(rs_tenant, tenantId)
            rs = rs.concat(rs_tenant)
          }
        }
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        rs.pop()
      }
      this.rowData = rs
      this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.fullscreenLoading = getLoading()
      this.proxy.state = this.isHistory ? PriceConstant.PRICE_STATE_HISTORY : PriceConstant.PRICE_STATE_EFFECTIVE
      queryPriceAirRealDetail(this.proxy).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.txtRemarks = ''
      this.fullscreenLoading.close()
    },
    onQuotation() {
      const user = this.$store.getters.userInfo
      if (!user.email || !user.userPhone || !user.fax) {
        this.$message.warning(this.$t('Pricing.PlsInputUserInfo'))
        return
      }
      const pl = this.selectedRow
      if (!pl) {
        this.$message.warning(this.$t('Pricing.noSelectedPrice'))
        return
      }
      const selectedItems = []
      const ql = PriceUtils.createQuotationAirDetail(pl)
      selectedItems.push(ql)
      const quotation = new Quotation().fillDefaultValue().getData()
      quotation.beginDate = new Date()
      quotation.endDate = !pl ? new Date() : pl.endDate
      quotation.type = PriceConstant.QUOTATION_AIR
      quotation.quotationAirDetail = selectedItems
      quotation.priceUuid = !pl ? null : (pl.uuid || null)
      quotation.bookingAgent = pl.bookingAgent
      quotation.carrier = pl.carrier
      quotation.region = resolveSpecificField2Value(TYPE_NAMES.basic_data_Airport, 'code', pl.pod, 'region')
      this.quotationDetail.quotation = quotation
      this.quotationDetail.showDetail = false
      this.quotationDetail.isEditing = true
      this.quotationDetail.visible = true
    },
    onSubscribe() {
      this.subscribe.visible = true
    },
    onSubscribeClose() {
      this.subscribe.visible = false
    },
    bookingAgentLabelFunc(data, value) {
      if (value === null) return ''
      const sourcePriceUuid = data.sourcePriceUuid
      if (!StrUtils.isEmpty(sourcePriceUuid)) {
        return this.tenantUtil.getTenantNameById(value)
      } else {
        return ColumnUtils.companyLabelFun(value, this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName', 'cmpIdx')
      }
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    // 行首多选框勾选事件
    onRowChecked(event) {
      if (event.node.isSelected()) {
        this.onRowClickedEvent(event)
      }
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.selectedRow = data
      this.txtRemarks = data.remarks
    },
    gridRefresh() {
      this.gridOptions.columnApi.setColumnVisible('fsc', !this.filter.allIn)
      this.gridOptions.columnApi.setColumnVisible('ssc', !this.filter.allIn)
      this.gridOptions.columnApi.setColumnVisible('tc', !this.filter.allIn)
      this.gridOptions.api.refreshCells({ force: true })
    },
    exportToExcel() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      this.exportDialog.visible = true
    },
    exportAll() {
      const fileName = PriceUtils.getFileName('PriceAirQuery')
      const rows = this.gridOptions.api.getSelectedRows()
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns], false)
      this.exportDialog.visible = false
    },
    ExportByTemplate() {
      this.fullscreenLoading = getLoading()
      const columnNames = { 'pol': 'POL', 'pod': 'POD', 'via': 'VIA', 'carrier': 'Carrier', 'minCharge': 'MIN', 'step': 'Normal', 'p45': '+45kg', 'p100': '+100kg', 'p300': '+300kg', 'p500': '+500kg', 'p1000': '+1000kg', 'fsc': 'FFC', 'ssc': 'SSC', 'days': 'T/T', 'frequency8': 'Frequency', 'beginDate': 'Valid from', 'endDate': 'Valid Until', 'aircraft': 'AIRCRAFT' }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const exportDatas = []
      const rows = this.gridOptions.api.getSelectedRows()
      const colDef = {}
      allDisplayedColumns.forEach(item => {
        if (columnNames.hasOwnProperty(item.getColId())) {
          colDef[item.getColId()] = item.getColDef()
        }
      })
      rows.map(item => { // 遍历行数据
        const exportData = {}
        const data = item
        for (const dataField in data) { // 遍历每个元素数据
          if (colDef.hasOwnProperty(dataField)) {
            exportData[dataField] = this.getCellData(colDef[dataField], item, dataField)
          }
        }
        exportData['frequency8'] = this.getCellData(colDef['frequency8'], item, 'frequency8')
        exportDatas.push(exportData)
      })
      exportByTemplate(exportDatas, this.filter.currency)
        .then((res) => {
          this.fullscreenLoading.close()
          this.exportDialog.visible = false
          this.$message.success(this.$t('Message.RequestSucceededExporting'))
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    getCellData(colDef, item, dataField) {
      let data = item.hasOwnProperty(dataField) ? item[dataField] : ''
      if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
        const params = { data: item, value: item[dataField], colDef }
        data = colDef.cellRenderer(params)
      } else if (colDef.valueFormatter && typeof colDef.valueFormatter !== 'string') {
        const params = { data: item, value: item[dataField], colDef }
        data = colDef.valueFormatter(params)
      }
      if (data && typeof data === 'string') {
        data = StrUtils.replaceSpecialCharacter(data)
      }
      return data
    }
  }
}
</script>
<style lang="scss">
</style>

